export const USER_TYPE = {
  /* eslint no-useless-computed-key: "off" */
  [0]: '管理员',
  [1]: '一牙云管理平台用户',
  [2]: 'app用户',
  [3]: '微信聊天用户',
  [4]: '患者用户',
  [5]: '门诊后台管理用户'
}

export const USER_OPTIONS = [
  {
    value: -1,
    label: '全部'
  },
  {
    value: 0,
    label: '管理员'
  },
  {
    value: 1,
    label: '一牙云管理平台用户'
  },
  {
    value: 2,
    label: 'app用户'
  },
  {
    value: 3,
    label: '微信聊天用户'
  },
  {
    value: 4,
    label: '患者用户'
  },
  {
    value: 5,
    label: '门诊后台管理用户'
  }
]

export const formRule = {
  userName: [
    { required: true, message: '账号未填写', trigger: 'blur' },
    { pattern: /^[0-9a-zA-Z_]{1,16}$/, message: '账号格式不正确' }
  ],
  mobile: [{ pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确' }],
  password: [
    { required: true, message: '密码未填写', trigger: 'blur' },
    { min: 6, max: 18, message: '密码长度为6到18位' }
  ]
}

export const updateFormRule = {
  username: [
    { required: true, message: '账号未填写', trigger: 'blur' },
    { pattern: /^[0-9a-zA-Z_]{1,16}$/, message: '账号格式不正确' }
  ],
  password: [{ min: 6, max: 18, message: '密码长度为6到18位' }]
}
